/** Chinese text: account, money, sign-in, registration, membership, rewards. See ../portalZh.ts. */
export const ZH_ACCOUNT: Readonly<Record<string, string>> = {
  'You need a family before you can top up Stars.': '充值星星前需要先创建家庭。',
  'Pick a pack. Bigger packs include bonus Stars.': '选一个套餐，大套餐附赠更多星星。',
  'Demo · fictional Harper family / Mia, age 10': '演示 · 虚构的 Harper 家庭 / Mia，10 岁',
  'Pre-generated result · simulated Plus membership and billing · snapshot 21 Oct 2026 · changes stay in this session.':
    '预生成结果 · 模拟的 Plus 会员与账单 · 2026 年 10 月 21 日快照 · 修改只在本次会话内有效。',
  'Reset this Demo': '重置此演示',
  'Exit Demo': '退出演示',
  'Invite code (optional)': '邀请码（选填）',
  'About your invite': '关于你的邀请',
  'The family who invited you will see that you joined, when your child makes a first creation, and when you book a first class. They will not see your child or your purchases.':
    '邀请你的家庭会看到你已加入、你的孩子完成第一个作品，以及你预约第一节课。对方看不到你的孩子或你的购买记录。',
  'a limited number of': '有限次数的',
  'the maximum': '上限金额',
  'Daily top-up limit reached': '已达到每日充值上限',
  "You've topped up {used} today, which is the daily safety limit ({cap}).":
    '你今天已充值 {used}，达到每日安全限额（{cap}）。',
  "You've topped up {used} today.": '你今天已充值 {used}。',
  'This protects your card if your account is ever accessed by someone else.':
    '这样即使账户被他人使用，也能保护你的银行卡。',
  'Limit resets {resets}.': '限额将于 {resets} 重置。',
  'Monthly top-up limit reached': '已达到每月充值上限',
  "You've topped up {used} this month, the monthly safety limit ({cap}).":
    '你本月已充值 {used}，达到每月安全限额（{cap}）。',
  "You've topped up {used} this month.": '你本月已充值 {used}。',
  'That pack is over the single top-up limit': '该套餐超过单次充值上限',
  'The most you can add in one top-up is {cap}.': '单次最多可充值 {cap}。',
  'This caps the damage if your card is ever misused.': '这样即使银行卡被盗用，损失也有上限。',
  'Too many top-ups this hour': '本小时充值次数过多',
  "For your card's safety you can make {count} top-ups per hour.":
    '为了你的银行卡安全，每小时最多充值 {count} 次。',
  'Please try again {resets}.': '请在 {resets} 后重试。',
  'Please try again shortly.': '请稍后重试。',
  'Too many top-ups today': '今天充值次数过多',
  "For your card's safety you can make {count} top-ups per day.":
    '为了你的银行卡安全，每天最多充值 {count} 次。',
  'Resets {resets}.': '将于 {resets} 重置。',
  'Top-up limit reached': '已达到充值上限',
  'Close top-up limit message': '关闭充值上限提示',
  OK: '好的',
  Starter: '入门',
  Mega: '超值',
  School: '学校',
  Popular: '热门',
  'Best value': '最划算',
  Stars: '星星',
  '({stars} + {bonus} bonus)': '（{stars} + 赠送 {bonus}）',
  'Powered by Airwallex. Cards charged in AUD.':
    '由 Airwallex 提供支付服务，银行卡以澳元（AUD）扣款。',
  'Complete result example': '完整成果示例',
  'Star Sprint': 'Star Sprint',
  'Play the finished project and read its full parent report. Fictional learner · pre-generated work.':
    '试玩完成的项目，并阅读完整的家长报告。虚构的学习者 · 预生成作品。',
  'Ready to play': '可以试玩',
  'Completed result views': '成果视图',
  'Play complete game': '试玩完整游戏',
  'Read full report': '阅读完整报告',
  'View complete source': '查看完整源码',
  'Reload original game': '重新加载原始游戏',
  'The complete index.html behind the playable result.': '这个可试玩成果背后的完整 index.html。',
  'This example shows the product’s result format. It does not claim independent learner authorship, a live AI run, a guaranteed outcome or completion of a real course.':
    '此示例展示产品的成果形式，并不代表学习者独立完成、实时 AI 运行、保证的学习效果或已完成真实课程。',
  '{amount} off a first class seat': '首个班级席位立减 {amount}',
  'minimum order {amount}': '最低消费 {amount}',
  'use within {days} days': '{days} 天内使用',
  '{amount} tuition credit': '{amount} 学费抵扣额度',
  '{stars} when the family adds a child.': '家庭添加孩子后获得 {stars}。',
  '{stars} when their child makes a first creation.': '对方孩子完成第一个作品后获得 {stars}。',
  '{amount} tuition credit when they pay for a first class, after the refund period.':
    '对方支付首个班级费用且退款期结束后，获得 {amount} 学费抵扣额度。',
  'You get {stars} when they add a child.': '对方添加孩子后，你将获得 {stars}。',
  'Next: they add a child.': '下一步：对方添加孩子。',
  'You get {stars} when their child makes a first creation.':
    '对方孩子完成第一个作品后，你将获得 {stars}。',
  'Next: their child makes a first creation.': '下一步：对方孩子完成第一个作品。',
  'You get {amount} credit when they book a first class.':
    '对方预约第一个班级后，你将获得 {amount} 抵扣额度。',
  'Next: they book a first class.': '下一步：对方预约第一个班级。',
  'In a checkout': '结账中',
  Used: '已使用',
  'Invite reward': '邀请奖励',
  'Welcome credit': '欢迎抵扣额度',
  'Adjustment by Airbotix': 'Airbotix 调整',
  'Used at checkout': '结账时已使用',
  'Reversed after a refund': '退款后已撤销',
  'Credit change': '额度变动',
  'Used on {date}': '使用于 {date}',
  'Expired {date}': '{date} 已过期',
  'Use by {date}': '请在 {date} 前使用',
  'Next-term voucher · {amount} off any class seat · use by {date}':
    '下学期代金券 · 任意班级席位立减 {amount} · 请在 {date} 前使用',
  'Next-term voucher · {amount} off any class seat': '下学期代金券 · 任意班级席位立减 {amount}',
  '{amount} off a class seat': '班级席位立减 {amount}',
  'Minimum order {amount}': '最低消费 {amount}',
  'For a first class seat only — not usable after your first class':
    '仅限首个班级席位使用，首次上课后不可再用',
  'Find a class': '查找班级',
  'Your rewards': '你的奖励',
  'Rewards are unavailable': '暂时无法显示奖励',
  'Your Stars, vouchers and credit have not been shown as empty.':
    '你的星星、代金券和抵扣额度并未被显示为空。',
  'Stars from rewards': '奖励获得的星星',
  History: '历史记录',
  '{amount} voucher': '{amount} 代金券',
  'Class vouchers': '班级代金券',
  'One voucher per order. A voucher cannot be combined with tuition credit or exchanged for cash.':
    '每笔订单限用一张代金券。代金券不能与学费抵扣额度叠加，也不能兑换现金。',
  'expires {date}': '{date} 到期',
  'Credit comes off automatically at your next class checkout.':
    '抵扣额度会在你下次班级结账时自动扣减。',
  'No rewards yet. Rewards appear here as soon as a task is done.':
    '还没有奖励。任务完成后，奖励会立即显示在这里。',
  Registered: '已注册',
  'First creation': '首个作品',
  'First class paid': '已支付首个班级',
  Reversed: '已撤销',
  Joined: '已加入',
  '+{stars} (registered)': '+{stars}（已注册）',
  '+{stars} (first creation)': '+{stars}（首个作品）',
  '{amount} credit on hold until {date}': '{amount} 抵扣额度冻结至 {date}',
  '{amount} credit on hold': '{amount} 抵扣额度冻结中',
  '{amount} credit granted': '已发放 {amount} 抵扣额度',
  '{amount} credit reversed': '已撤销 {amount} 抵扣额度',
  'Joined {date}': '{date} 加入',
  'Registered {date}': '{date} 注册',
  'First creation {date}': '{date} 完成首个作品',
  'First class paid {date}': '{date} 支付首个班级',
  'Reversed {date}': '{date} 已撤销',
  'Your reward: {rewards}': '你的奖励：{rewards}',
  'My invites': '我的邀请',
  'Invites are unavailable': '暂时无法显示邀请',
  'Your invites have not been shown as empty.': '你的邀请并未被显示为空。',
  Invited: '已邀请',
  'Stars earned': '已获得星星',
  'Credit granted': '已发放抵扣额度',
  'No invites yet. Families who join with your link appear here.':
    '还没有邀请。通过你的链接加入的家庭会显示在这里。',
  "You see each family's progress only. You never see their child, their courses or what they pay.":
    '你只能看到每个家庭的进度，看不到对方的孩子、课程或支付金额。',
  'Repeats each week, up to a limit': '每周重复，有次数上限',
  'Repeats each month, up to a limit': '每月重复，有次数上限',
  'For families who have not paid for a class yet': '适用于尚未支付班级费用的家庭',
  'Not available — for new families': '不可用，仅限新家庭',
  'Done on {date}': '{date} 完成',
  'Done · Done before rewards started': '已完成 · 奖励开始前已完成',
  '{done} of {total} done': '已完成 {done}/{total}',
  'To do': '待办',
  'Ends {date}': '{date} 结束',
  'Starter tasks': '新手任务',
  'Tasks are unavailable': '暂时无法显示任务',
  'Rewards you have earned are not lost. Try again in a moment.':
    '你已获得的奖励不会丢失。请稍后重试。',
  '{done} done · {pending} to do': '已完成 {done} · 待办 {pending}',
  'Stars go to your family wallet. A class voucher comes off at class checkout and cannot be combined with tuition credit or exchanged for cash.':
    '星星会存入你的家庭钱包。班级代金券在班级结账时抵扣，不能与学费抵扣额度叠加，也不能兑换现金。',
  'See rewards': '查看奖励',
  'Get started with your child. Airbotix adds each reward when the task is done.':
    '和孩子一起开始吧。任务完成后，Airbotix 会发放对应奖励。',
  'More ways to earn': '更多获得奖励的方式',
  Shared: '已分享',
  'Link copied. Paste it into a message to your family.': '链接已复制，粘贴到消息里发给家人吧。',
  'Anyone with this link can play it. You can turn the link off at any time.':
    '任何拿到链接的人都能试玩。你可以随时关闭链接。',
  'Share link': '分享链接',
  'Manage share links': '管理分享链接',
  "Share {kidName}'s {kindLabel} with family": '与家人分享{kidName}的{kindLabel}',
  game: '游戏',
  story: '故事',
  website: '网站',
  creation: '作品',
  '“{title}” · Family and friends can play it from a link. No sign-in, no comments.':
    '“{title}” · 家人和朋友可通过链接试玩，无需登录，也没有评论。',
  'Show “{name}” on the share page (first name only). If you leave this off, the page shows only an age range.':
    '在分享页显示“{name}”（仅名字）。如果不勾选，页面只显示年龄段。',
  "We couldn't share it just now. Try again in a moment.": '暂时无法分享，请稍后重试。',
  'Sharing…': '分享中…',
  'Share with family': '与家人分享',
  'Not now': '暂不',
  'Ends in 1 hour': '1 小时后结束',
  'Ends in {hours} hours': '{hours} 小时后结束',
  'Ends in 1 day ({date})': '1 天后结束（{date}）',
  'Ends in {days} days ({date})': '{days} 天后结束（{date}）',
  'We could not check that code right now. Try again.': '暂时无法验证该优惠码，请重试。',
  'Enter a coupon code.': '请输入优惠码。',
  'Teacher code': '老师代码',
  'Workshop code': '工作坊代码',
  '{code} applied — thanks for booking through your teacher. This code has no discount.':
    '已使用 {code}，感谢你通过老师预约。此代码没有折扣。',
  '{code} applied — {amount} off': '已使用 {code}，立减 {amount}',
  Remove: '移除',
  'Have a coupon code?': '有优惠码吗？',
  'Coupon code': '优惠码',
  Apply: '使用',
  'Choose “Use Tuition Credit instead” to use a coupon.':
    '如需使用优惠码，请选择“改用学费抵扣额度”。',
  'Could not set default.': '无法设为默认。',
  'Could not remove card.': '无法移除银行卡。',
  'Payment method': '支付方式',
  'Choose the exact card to use for automatic charges.': '选择用于自动扣款的银行卡。',
  'Manage your securely saved cards.': '管理你安全保存的银行卡。',
  'Add a card': '添加银行卡',
  'No saved card yet': '还没有保存的银行卡',
  'Add one before switching auto-topup on.': '开启自动充值前，请先添加一张银行卡。',
  'Saved payment methods': '已保存的支付方式',
  'Expires {date}': '有效期至 {date}',
  Default: '默认',
  'Make default': '设为默认',
  'Remove {brand} ending {last4}': '移除尾号为 {last4} 的 {brand} 卡',
  'Remove this card? Auto-topup may pause if no other card is available.':
    '要移除这张卡吗？如果没有其他可用的卡，自动充值可能会暂停。',
  'Keep card': '保留银行卡',
  'Remove card': '移除银行卡',
  'Card saved securely.': '银行卡已安全保存。',
  'Invite your friends': '邀请朋友',
  'Invite details are unavailable': '暂时无法显示邀请详情',
  'Your code and earned credit have not been shown as empty.':
    '你的邀请码和已获得的抵扣额度并未被显示为空。',
  'Invites are paused on this account. Contact Airbotix support if you think this is a mistake.':
    '此账户的邀请功能已暂停。如果你认为这是误操作，请联系 Airbotix 客服。',
  'Link copied. Paste it into a message to your friends.': '链接已复制，粘贴到消息里发给朋友吧。',
  'Select the link above and copy it.': '请选中上方的链接并复制。',
  'Share your link with families you know. You earn rewards as the family you invite gets started.':
    '把链接分享给你认识的家庭。你邀请的家庭开始使用后，你就能获得奖励。',
  'After your first class payment, you also earn tuition credit when an invited family pays.':
    '完成首个班级付款后，被邀请的家庭付费时你还能获得学费抵扣额度。',
  'Paid for a class': '已支付班级费用',
  'Your credit': '你的抵扣额度',
  'Your credit comes off automatically at your next course checkout.':
    '你的抵扣额度会在下次课程结账时自动扣减。',
  'Use it by {date} or it expires.': '请在 {date} 前使用，否则将过期。',
  'We couldn’t check the next expiry date. Your credit balance above is unchanged.':
    '暂时无法查询下一个到期日。上方的抵扣额度余额不受影响。',
  'Get your invite link and share it with families you know.':
    '获取你的邀请链接，分享给你认识的家庭。',
  'Getting your link…': '正在获取链接…',
  'Get my invite link': '获取我的邀请链接',
  "Couldn't get a link just now. Try again in a moment.": '暂时无法获取链接，请稍后重试。',
  'I allow Airbotix to securely save this card and charge it automatically for Stars top-ups, up to the limits I set, until I remove it.':
    '我允许 Airbotix 安全保存这张银行卡，并在我设定的限额内为星星充值自动扣款，直到我将其移除。',
  'Card setup isn’t switched on yet. Please check back soon.':
    '银行卡设置功能暂未开启，请稍后再来。',
  'We couldn’t load the secure card form. Check your connection and try again.':
    '无法加载安全的银行卡表单。请检查网络后重试。',
  'That card form had a problem. Close and try again.': '银行卡表单出现问题。请关闭后重试。',
  'We couldn’t show the secure card form.': '无法显示安全的银行卡表单。',
  'The card was verified, but its safe display details were incomplete. Please close this form and try again.':
    '银行卡已通过验证，但可显示的安全信息不完整。请关闭此表单后重试。',
  'We couldn’t save that card. Please try again.': '无法保存这张银行卡，请重试。',
  'Close add card': '关闭添加银行卡',
  'Your card is handled by Airwallex. We never see or store your card number.':
    '你的银行卡由 Airwallex 处理，我们不会看到或保存你的卡号。',
  'Loading secure form…': '正在加载安全表单…',
  'Loading card form…': '正在加载银行卡表单…',
  'Save card': '保存银行卡',
  'Your card is saved securely. You can now turn on auto-topup.':
    '你的银行卡已安全保存，现在可以开启自动充值了。',
  'Payment history': '付款记录',
  'Every Stars Pack you bought — card and auto top-ups, plus refunds. Receipts via Airwallex.':
    '你购买的每个星星套餐，包括银行卡充值、自动充值和退款。收据由 Airwallex 提供。',
  '+ Top up': '+ 充值',
  'Loading saved cards': '正在加载已保存的银行卡',
  'We couldn’t load your saved cards': '无法加载你已保存的银行卡',
  'No card has been labelled as missing or removed.': '没有任何银行卡被标记为丢失或已移除。',
  'Purchases & refunds': '购买与退款',
  'We couldn’t load purchases and refunds': '无法加载购买与退款记录',
  'Your payment history has not been replaced with an empty list.':
    '你的付款记录并未被替换为空列表。',
  'Card top-up': '银行卡充值',
  Refund: '退款',
  refund: '退款',
  paid: '已支付',
  'Load more purchases': '加载更多购买记录',
  'No purchases': '暂无购买',
  "You haven't bought any Stars yet.": '你还没有购买过星星。',
  'Top up Stars →': '充值星星 →',
  'Paid via Airwallex. For tax invoices, email': '通过 Airwallex 支付。如需税务发票，请发送邮件至',
  'Could not pause.': '无法暂停。',
  'Could not resume.': '无法恢复。',
  'Your Stars': '你的星星',
  'Track your balance, limits, and what you spent Stars on.':
    '查看你的余额、额度，以及星星花在了哪里。',
  'Track balance, limits, and what your kids spent on.':
    '查看余额、额度，以及孩子们把星星花在了哪里。',
  'Auto-topup': '自动充值',
  Resume: '恢复',
  Pause: '暂停',
  'Loading wallet': '正在加载钱包',
  'We couldn’t load your Stars balance': '无法加载你的星星余额',
  'Your real balance and limits have not been replaced with zero values.':
    '你的真实余额和额度并未被替换为零。',
  'All kid spending is blocked until you resume.': '恢复之前，孩子们的所有消费都会被阻止。',
  Balance: '余额',
  'Recent activity': '最近动态',
  'We couldn’t load recent activity': '无法加载最近动态',
  'No transactions are being hidden behind an empty-state message.':
    '没有任何交易被隐藏在空状态提示后面。',
  'membership grant': '会员发放',
  'topup card': '银行卡充值',
  'workshop credit': '工作坊额度',
  'agent spend': 'AI 助手消耗',
  'mission reward': '任务奖励',
  'admin adjust': '管理员调整',
  'Membership — monthly Stars allowance': '会员 · 每月星星额度',
  'Self-paced course — purchase bonus': '自学课程 · 购买赠送',
  'Self-paced course — bonus withdrawn on refund': '自学课程 · 退款后收回赠送',
  'Creative Code Studio — AI build turn': 'Creative Code Studio · AI 创作一轮',
  'Website Studio — AI build turn': 'Website Studio · AI 创作一轮',
  'Code Studio — AI build turn': 'Code Studio · AI 创作一轮',
  'Chatbot Studio — AI build turn': 'Chatbot Studio · AI 创作一轮',
  'Chatbot Studio — bot reply': 'Chatbot Studio · 机器人回复',
  'AI chat reply': 'AI 聊天回复',
  'Load more activity': '加载更多动态',
  'All clear': '一切正常',
  'No activity yet. Top up to get started.': '还没有动态。充值后即可开始使用。',
  'Could not save caps.': '无法保存额度。',
  Limits: '额度',
  Edit: '编辑',
  Daily: '每日',
  Weekly: '每周',
  Monthly: '每月',
  'Per request': '每次请求',
  'Edit limits': '编辑额度',
  'Save limits': '保存额度',
  'Could not export CSV.': '无法导出 CSV。',
  'Loading family usage…': '正在加载家庭用量…',
  'Usage is unavailable right now': '暂时无法显示用量',
  "We couldn't load the family usage totals. No activity has been hidden or counted as zero.":
    '无法加载家庭用量汇总。没有任何动态被隐藏或按零计算。',
  'How much AI your family used — Stars, requests, and which kid. No prompts or content stored here.':
    '你的家庭使用了多少 AI：星星、请求次数，以及是哪个孩子。这里不保存任何提示词或内容。',
  'Exporting…': '导出中…',
  'Export CSV ({range})': '导出 CSV（{range}）',
  'Stars spent': '已花费星星',
  'AI requests': 'AI 请求',
  'Stars vs previous period': '与上一周期相比的星星变化',
  'Top kid': '使用最多的孩子',
  'Top model': '使用最多的模型',
  'Per kid': '按孩子统计',
  '1 request': '1 次请求',
  '{count} requests': '{count} 次请求',
  'Details →': '详情 →',
  'No usage yet': '暂无用量',
  'Once you start creating, your AI usage shows up here.': '你开始创作后，AI 用量会显示在这里。',
  'Once your kids start creating, their AI usage shows up here.':
    '孩子们开始创作后，他们的 AI 用量会显示在这里。',
  'Your export is large — we’ll email you a download link.':
    '导出内容较大，我们会把下载链接发到你的邮箱。',
  'Could not export. Try again.': '无法导出，请重试。',
  '{name} — Star usage': '{name} · 星星用量',
  'Last {days} days. Stars, requests, time, and what they used the AI for.':
    '最近 {days} 天的星星、请求次数、时长，以及 AI 的用途。',
  'Export CSV': '导出 CSV',
  "We couldn't load this child's usage. No activity has been counted as zero.":
    '无法加载这个孩子的用量。没有任何动态被按零计算。',
  'No data': '暂无数据',
  'No usage for this kid in the last {days} days.': '这个孩子最近 {days} 天没有用量。',
  Requests: '请求',
  Minutes: '分钟',
  Tokens: '令牌数',
  'Daily Stars': '每日星星',
  'The daily usage chart is unavailable.': '暂时无法显示每日用量图表。',
  'What they made': '他们创作了什么',
  'By tool': '按工具',
  'By model': '按模型',
  'Flagged responses': '被标记的回复',
  '{granted}/{asked} granted': '已批准 {granted}/{asked}',
  'Nothing yet.': '暂无内容。',
  'The price appears first': '先看价格',
  'Your child sees the Star cost before starting a paid AI action.':
    '孩子在开始付费 AI 操作之前，会先看到需要花多少星星。',
  'You stay in control': '一切由你掌控',
  'Set daily, weekly, monthly, and per-action limits, or pause spending.':
    '可设置每日、每周、每月和单次操作的额度，也可以暂停消费。',
  'You can check every use': '每次使用都能查看',
  'Star usage shows which child and task used the family balance.':
    '星星用量会显示是哪个孩子、哪项任务用了家庭余额。',
  'Failed creations cost nothing': '失败的创作不收费',
  'Blocked requests are not charged. Failed paid creations return the Stars.':
    '被拦截的请求不收费；付费创作失败时，星星会退回。',
  'What is an AI token?': '什么是 AI 令牌（token）？',
  'AI systems split instructions and answers into small pieces called tokens. Providers use tokens to measure some text AI work. Image, music, voice, and video tools use other technical units. You do not need to buy or count any of them in Airbotix.':
    'AI 系统会把指令和回答拆成很小的片段，称为令牌（token）。服务商用令牌来计量部分文字类 AI 工作。图片、音乐、语音和视频工具则使用其他技术单位。在 Airbotix 中，你不需要购买或计算其中任何一种。',
  'Is one Star the same as one token?': '一颗星星等于一个令牌吗？',
  'No. A Star is a simple prepaid Airbotix credit. It turns changing model, token, and media-generation costs into one clear price that your family sees before a paid AI action.':
    '不等于。星星是 Airbotix 简单的预付额度，它把不断变化的模型、令牌和多媒体生成成本，变成家庭在付费 AI 操作前就能看到的一个清晰价格。',
  'Why do I top up Stars after paying for a class?': '为什么付完班级费用后还要充值星星？',
  'The class fee pays for the teacher, learning plan, feedback, and classroom experience. Stars pay only for the external AI computing power your child chooses to use. Keeping them separate avoids raising every class fee for families who use less AI.':
    '班级费用用于支付老师、学习计划、反馈和课堂体验。星星只用于支付孩子选择使用的外部 AI 算力。两者分开，就不必为了少用 AI 的家庭而抬高每个班级的费用。',
  'Does every click use Stars?': '每次点击都会消耗星星吗？',
  'No. Reading lessons, planning, drawing, coding by hand, running saved work, and editing without an AI model do not use Stars. A paid AI action shows its Star price before it starts.':
    '不会。阅读课节、做计划、画画、手写代码、运行已保存的作品，以及不使用 AI 模型的编辑，都不消耗星星。付费 AI 操作在开始前会显示所需星星。',
  'Why do different AI tools use different numbers of Stars?':
    '为什么不同的 AI 工具消耗的星星数量不同？',
  'Different models need different amounts of computing power. A short text answer can cost less than making an image, voice, song, or video. Airbotix shows the current Star price before each paid action.':
    '不同模型需要的算力不同。一段简短的文字回答，成本可能比生成图片、语音、歌曲或视频更低。每次付费操作前，Airbotix 都会显示当前的星星价格。',
  'Can my child create an unexpected bill?': '孩子会产生意外账单吗？',
  'Stars are prepaid. Paid AI pauses when the balance or a family limit is reached. Parents can review usage, set limits, or pause spending. Blocked requests cost nothing, and failed paid creations return their Stars.':
    '星星是预付的。余额不足或达到家庭额度时，付费 AI 会暂停。家长可以查看用量、设置额度或暂停消费。被拦截的请求不收费，付费创作失败时星星会退回。',
  'Stars guide': '星星指南',
  'Why AI needs Stars': 'AI 为什么需要星星',
  'Think of AI like a car. A car needs petrol to move. AI needs paid computing power to read a request and create something new. Stars are the simple, prepaid fuel gauge your family sees.':
    '把 AI 想象成一辆汽车。汽车需要汽油才能行驶，AI 需要付费的算力才能理解请求并创造新内容。星星就是你的家庭看到的、简单的预付油表。',
  'A parent fills an AI creation machine with Star fuel while a child makes pictures, music, and stories.':
    '家长为 AI 创作机器加满星星燃料，孩子则在创作图片、音乐和故事。',
  'Stars go into AI tools like petrol goes into a car. The gauge shows the prepaid fuel available; each paid creation uses a visible amount.':
    '星星用在 AI 工具上，就像汽油加进汽车。油表显示剩余的预付燃料，每次付费创作消耗的数量都清清楚楚。',
  'What each payment covers': '每项费用包含什么',
  'Class fee': '班级费用',
  'The guide and the learning path': '指导与学习路径',
  'Teacher time and support': '老师的时间与支持',
  'Planned lessons and projects': '精心设计的课节与项目',
  'Classroom feedback and progress': '课堂反馈与学习进度',
  'The fuel for AI creation': 'AI 创作的燃料',
  'AI help with ideas and words': 'AI 帮忙想点子、写文字',
  'New pictures, music, voices, or video': '生成新的图片、音乐、语音或视频',
  'Different tools use different numbers of Stars': '不同工具消耗的星星数量不同',
  'AI providers charge for each creation. Keeping Stars separate means your family pays for the AI it uses, while the class price stays focused on teaching. A child can still read lessons, plan, draw, code, and improve saved work without spending Stars when no AI model is used.':
    'AI 服务商会对每次创作收费。把星星单独计费，意味着家庭只为实际使用的 AI 付费，班级价格则专注于教学。不使用 AI 模型时，孩子仍然可以阅读课节、做计划、画画、写代码和改进已保存的作品，不会消耗星星。',
  'No open-ended bill': '没有无上限的账单',
  'Stars are prepaid. When the balance or a limit is reached, paid AI creation stops.':
    '星星是预付的。余额用完或达到额度时，付费 AI 创作就会停止。',
  'Parent FAQ': '家长常见问题',
  'Tokens, top-ups, and Star costs': '令牌、充值与星星成本',
  'You do not need to understand AI billing terms before your child can create safely.':
    '你不需要先弄懂 AI 的计费术语，孩子也能安全地创作。',
  'Many technical AI units are simplified into prepaid Stars, which fuel an AI creation machine like petrol fuels a car.':
    '许多技术性的 AI 计量单位被简化为预付星星，为 AI 创作机器提供燃料，就像汽油为汽车提供燃料。',
  'AI providers measure many changing technical units. Airbotix converts those costs into simple prepaid Stars. Petrol is the everyday comparison: fill the tank, check the gauge, and use fuel only when the engine runs.':
    'AI 服务商使用许多不断变化的技术单位来计量。Airbotix 把这些成本换算成简单的预付星星。汽油是我们日常的类比：加满油箱，看看油表，只有发动机运转时才会用掉燃料。',
  'AI tokens, Stars, and petrol compared': 'AI 令牌、星星与汽油的类比',
  'AI tokens': 'AI 令牌',
  'Technical units used behind the scenes. They vary by model and type of creation.':
    '幕后使用的技术单位，会因模型和创作类型而异。',
  'Simple prepaid family credits that turn changing AI costs into one visible price.':
    '简单的家庭预付额度，把不断变化的 AI 成本变成一个看得见的价格。',
  Petrol: '汽油',
  'The everyday comparison: fill the tank first, then use fuel when the engine runs.':
    '日常类比：先加满油箱，发动机运转时才会用掉燃料。',
  "Tokens are the provider's measurements. Stars are what your family buys. Petrol is the simple way to understand how Stars power AI.":
    '令牌是服务商的计量方式，星星是你的家庭购买的东西，汽油则是理解星星如何驱动 AI 的简单类比。',
  'See Star packs': '查看星星套餐',
  'View Star usage': '查看星星用量',
  'Set limits': '设置额度',
  'Stars, class vouchers and tuition credit you earn stay on your account.':
    '你获得的星星、班级代金券和学费抵扣额度都会保存在你的账户中。',
  'Campaign rewards': '活动奖励',
  'Campaign rewards stay on your account. There is no public code to lose or share.':
    '活动奖励保存在你的账户中，没有可能丢失或被分享的公开代码。',
  'Loading your rewards…': '正在加载你的奖励…',
  'Ready to use': '可以使用',
  '90-minute Workshop seat': '90 分钟工作坊席位',
  'Choose an eligible Workshop in Courses. Your prize applies automatically at checkout, so there is nothing to pay.':
    '在课程中选择一个符合条件的工作坊。奖品会在结账时自动抵扣，无需支付。',
  'Use by': '使用期限',
  Entry: '参与编号',
  'Choose a Workshop': '选择工作坊',
  'This reward was replaced with the A$50 voucher shown on your account.':
    '此奖励已替换为你账户中显示的 A$50 代金券。',
  fulfilled: '已完成',
  delivered: '已送达',
  substituted: '已替换',
  void: '已作废',
  available: '可用',
  redeemed: '已使用',
  reserved: '已预留',
  '{amount} class voucher': '{amount} 班级代金券',
  'Minimum class order': '班级最低消费',
  'Find an eligible class': '查找符合条件的班级',
  'Applied during class checkout. Cannot be combined with Tuition Credit or exchanged for cash.':
    '在班级结账时使用。不能与学费抵扣额度叠加，也不能兑换现金。',
  Credited: '已到账',
  Processing: '处理中',
  '100 Airbotix Stars': '100 颗 Airbotix 星星',
  'The Stars are in your family wallet.': '星星已存入你的家庭钱包。',
  'Complete Family setup. Airbotix will credit this secured reward safely.':
    '完成家庭设置后，Airbotix 会安全地把这份已保留的奖励发放给你。',
  'Entry {number}': '参与编号 {number}',
  'No campaign rewards yet': '还没有活动奖励',
  'Your claimed rewards will appear here automatically.': '你领取的奖励会自动显示在这里。',
  'We could not load your rewards right now.': '暂时无法加载你的奖励。',
  'We could not link this student just now. Nothing was changed. Try again.':
    '暂时无法关联这位学生，没有任何内容被更改。请重试。',
  'This invite link has expired, was cancelled, or was already used. Ask the student to send a new invite.':
    '此邀请链接已过期、已被取消或已被使用。请让学生重新发送邀请。',
  'This invite was already accepted. {nickname} is already in a family.':
    '此邀请已被接受，{nickname} 已经在一个家庭中。',
  'This invite was sent to {email}. Sign out, then sign in with that email to accept it.':
    '此邀请发送至 {email}。请先退出登录，再用该邮箱登录以接受邀请。',
  '{nickname} is already linked to a family, so this invite cannot be used.':
    '{nickname} 已经关联了一个家庭，因此无法使用此邀请。',
  '{nickname} has a payment that is still processing. Try again in a few minutes.':
    '{nickname} 有一笔付款仍在处理中，请几分钟后重试。',
  'Your family already has {max} kids, which is the most a family can have.':
    '你的家庭已经有 {max} 个孩子，这是一个家庭的上限。',
  'Your family already has the most kids a family can have.': '你的家庭已经达到孩子数量的上限。',
  'Your family account cannot take a new student right now. Contact Airbotix support.':
    '你的家庭账户暂时无法添加新学生。请联系 Airbotix 客服。',
  'Your email is already the main email of another family account. Contact Airbotix support.':
    '你的邮箱已经是另一个家庭账户的主邮箱。请联系 Airbotix 客服。',
  'Only a parent account can accept this invite. Sign in with a parent account.':
    '只有家长账户可以接受此邀请。请使用家长账户登录。',
  'Linking a student account is not available right now. The invite is still saved. Try again later.':
    '暂时无法关联学生账户，邀请仍然有效。请稍后再试。',
  '{nickname} joins your family. If you do not have a family account yet, their account becomes your family account.':
    '{nickname} 会加入你的家庭。如果你还没有家庭账户，对方的账户将成为你的家庭账户。',
  'Their Stars move into your family wallet, and your payment methods pay from now on. Their saved cards are removed and their auto top-up turns off.':
    '对方的星星会转入你的家庭钱包，此后由你的支付方式付款。对方保存的银行卡会被移除，自动充值也会关闭。',
  'Only Stars move. Class credits and vouchers on {nickname}’s old account stay there and do not move to your family.':
    '只有星星会转移。{nickname} 旧账户上的班级额度和代金券会留在原账户，不会转到你的家庭。',
  'You will see their progress, reports and spending, the same as for your other kids.':
    '你可以像查看其他孩子一样，查看对方的学习进度、报告和消费。',
  'This cannot be undone.': '此操作无法撤销。',
  'Neither you nor {nickname} can remove the link later.':
    '之后你和 {nickname} 都无法解除这个关联。',
  '{nickname} keeps signing in with their own email.': '{nickname} 仍然用自己的邮箱登录。',
  'This invite cannot be used': '此邀请无法使用',
  'The link has expired, was cancelled, or was already used. Ask the student to send a new invite from their Airbotix profile.':
    '链接已过期、已被取消或已被使用。请让学生在 Airbotix 个人资料中重新发送邀请。',
  'Go to the Parent Portal': '前往家长中心',
  'Linking is paused right now': '关联功能暂时关闭',
  Linked: '已关联',
  '{name} is now in your family': '{name} 已加入你的家庭',
  'Your family account was set up from {name}’s account.': '你的家庭账户是由 {name} 的账户创建的。',
  '{count} Stars moved into your family wallet.': '{count} 星星已转入你的家庭钱包。',
  '{name}’s saved card was removed. Your payment methods pay from now on.':
    '{name} 保存的银行卡已被移除，此后由你的支付方式付款。',
  '{name}’s saved cards were removed. Your payment methods pay from now on.':
    '{name} 保存的银行卡已被移除，此后由你的支付方式付款。',
  '{name} needs to sign in again with their email to see the family.':
    '{name} 需要用自己的邮箱重新登录，才能看到家庭。',
  'Go to my family →': '前往我的家庭 →',
  'Opening the invite…': '正在打开邀请…',
  'We could not open this invite just now.': '暂时无法打开此邀请。',
  'Family invite': '家庭邀请',
  'Accept {nickname} into your family': '接受 {nickname} 加入你的家庭',
  '{nickname} signed up for Airbotix with their own email and asked you to join as their parent. This invite was sent to {email} and works until {date}.':
    '{nickname} 用自己的邮箱注册了 Airbotix，并邀请你作为家长加入。此邀请发送至 {email}，有效期至 {date}。',
  'What happens when you accept': '接受后会发生什么',
  'Checking your sign-in…': '正在检查你的登录状态…',
  'Sign in to the Parent Portal with {email}. No account yet? Use that email to create one. You come back here after.':
    '请用 {email} 登录家长中心。还没有账户？用这个邮箱创建一个即可，完成后会回到这里。',
  'Sign in or create a parent account': '登录或创建家长账户',
  'Sign out and use another account': '退出登录并使用其他账户',
  'Linking…': '关联中…',
  'Accept {nickname}': '接受 {nickname}',
  'Enter a valid email address': '请输入有效的邮箱地址',
  'At least 8 characters': '至少 8 个字符',
  '6 digits': '6 位数字',
  'Could not check this email. Try again.': '无法验证这个邮箱，请重试。',
  'Could not send code. Try again.': '无法发送验证码，请重试。',
  'Verification failed.': '验证失败。',
  'Email or password is incorrect. You can sign in with a code instead.':
    '邮箱或密码不正确。你也可以改用验证码登录。',
  'Login failed. Try again.': '登录失败，请重试。',
  'Parents, guardians & students': '家长、监护人和学生',
  Welcome: '欢迎',
  'Enter your code.': '请输入验证码。',
  'Continue with your email.': '继续使用你的邮箱。',
  'Enter your email to log in or create a parent account. Students with their own account can sign in here too.':
    '输入邮箱即可登录或创建家长账户。拥有自己账户的学生也可以在这里登录。',
  'We sent a 6-digit code to {email}.': '我们已向 {email} 发送了 6 位验证码。',
  'Use your password or get a secure login code.': '使用密码登录，或获取安全的登录验证码。',
  'Create your parent account with a secure email code.': '通过安全的邮箱验证码创建你的家长账户。',
  Continue: '继续',
  'Your email': '你的邮箱',
  Change: '更改',
  'This email belonged to a closed student account.': '这个邮箱属于一个已关闭的学生账户。',
  'No parent account was created. To make a parent account, use a different email, or contact Airbotix support.':
    '没有创建家长账户。如需创建家长账户，请使用其他邮箱，或联系 Airbotix 客服。',
  'Check your inbox': '请查收邮件',
  '6-digit code': '6 位验证码',
  'Verifying…': '验证中…',
  Verify: '验证',
  'Sending another code…': '正在重新发送验证码…',
  'Send another code': '重新发送验证码',
  'Welcome back': '欢迎回来',
  'Students with a password can sign in with it here.': '设置了密码的学生可以在这里用密码登录。',
  Password: '密码',
  'Your password': '你的密码',
  'Signing in…': '登录中…',
  'Log in': '登录',
  'Sending code…': '正在发送验证码…',
  'Log in with an email code': '用邮箱验证码登录',
  'New to Airbotix?': '第一次使用 Airbotix？',
  'We will email a secure code, then help you set up your family. Already have a student account? The code signs you in to it.':
    '我们会发送一个安全验证码到你的邮箱，然后帮你设置家庭。已经有学生账户？这个验证码会让你登录该账户。',
  'Send code to create account': '发送验证码并创建账户',
  'I have a student password': '我有学生密码',
  'Could not save.': '无法保存。',
  'We couldn’t load account settings': '无法加载账户设置',
  'No account or family details are being shown as blank.': '没有任何账户或家庭信息被显示为空白。',
  'Account & family': '账户与家庭',
  'Loading family settings': '正在加载家庭设置',
  'We couldn’t load the family profile': '无法加载家庭资料',
  'The form is hidden so blank fields cannot overwrite your saved details.':
    '表单已隐藏，以免空白字段覆盖你已保存的信息。',
  'Family profile': '家庭资料',
  Basics: '基本信息',
  'Family name': '家庭名称',
  Region: '地区',
  'City (optional)': '城市（选填）',
  State: '州',
  'Choose a valid Australian state.': '请选择有效的澳大利亚州。',
  Postcode: '邮政编码',
  'Postcode must be 8 characters or fewer.': '邮政编码不能超过 8 个字符。',
  'School name (optional)': '学校名称（选填）',
  'Sunnydale Public School': 'Sunnydale Public School',
  'School name must be 120 characters or fewer.': '学校名称不能超过 120 个字符。',
  Preferences: '偏好设置',
  'Preferred language': '首选语言',
  'Choose a supported language.': '请选择支持的语言。',
  'Student accounts do not get tips or updates by email.':
    '学生账户不会收到邮件形式的小贴士或动态。',
  'Send me tips & updates about Airbotix. No spam — promise.':
    '向我发送 Airbotix 的小贴士和最新动态。绝不发垃圾邮件。',
  'About your family (optional)': '关于你的家庭（选填）',
  'Your occupation (optional)': '你的职业（选填）',
  'Occupation must be 120 characters or fewer.': '职业不能超过 120 个字符。',
  'Your industry (optional)': '你的行业（选填）',
  Education: '教育',
  'Industry must be 120 characters or fewer.': '行业不能超过 120 个字符。',
  'Changes apply to the parent portal and kid sign-in profile.':
    '修改会同步到家长中心和孩子登录资料。',
  'Save changes': '保存修改',
  'No family linked': '尚未关联家庭',
  'Complete family setup before editing portal settings.': '请先完成家庭设置，再修改家长中心设置。',
  Role: '角色',
  'Sign out everywhere': '退出所有设备',
  'Data export': '数据导出',
  'Download everything': '下载全部数据',
  'All family data: parents, kids, wallet, transactions, projects, audit events. Downloads as a zip file to your device.':
    '全部家庭数据：家长、孩子、钱包、交易、项目和审计记录，将以 zip 文件下载到你的设备。',
  'Preparing…': '准备中…',
  'Download my family data': '下载我的家庭数据',
  'Export failed.': '导出失败。',
  'Your download has started ({count} files). If it did not start,':
    '下载已开始（共 {count} 个文件）。如果没有开始，请',
  'use this link': '点击此链接',
  '. It works for {hours} hours.': '。链接 {hours} 小时内有效。',
  'Danger zone': '危险操作',
  'Delete this family': '删除此家庭',
  'Soft-deletes everything. 30-day grace period before hard delete. Sign out everywhere immediately.':
    '所有内容会先被软删除，30 天宽限期后才会彻底删除。你会立即在所有设备上退出登录。',
  'Delete family': '删除家庭',
  'Confirm family deletion': '确认删除家庭',
  'Delete {name}? You have a 30-day recovery period.': '要删除 {name} 吗？你有 30 天的恢复期。',
  'Delete this family? You have a 30-day recovery period.': '要删除此家庭吗？你有 30 天的恢复期。',
  'Keep family': '保留家庭',
  'Delete failed.': '删除失败。',
  'Could not save password.': '无法保存密码。',
  'Log in faster with your email + password. You can still use a code anytime.':
    '用邮箱加密码登录更快捷，你也可以随时改用验证码登录。',
  'Optional — set a password to log in without waiting for a code each time.':
    '选填：设置密码后，登录时不必每次等待验证码。',
  'New password': '新密码',
  'Set password': '设置密码',
  'At least 8 characters.': '至少 8 个字符。',
  'Password saved': '密码已保存',
  'Display name': '显示名称',
  'Your name': '你的姓名',
  ' to Airbotix.': '来到 Airbotix。',
  'Invite codes are 40 characters or fewer': '邀请码不能超过 40 个字符',
  'You need to agree before we can set up your family.': '同意后，我们才能为你设置家庭。',
  'Nickname is required': '请填写昵称',
  'Enter the kid code from the workshop': '请输入工作坊提供的孩子代码',
  'Mobile number is required.': '请填写手机号码。',
  'You can close this tab and go back to Hangar.': '你可以关闭此标签页，返回 Hangar。',
  'Open the Parent Portal instead': '改为打开家长中心',
  'Your family': '你的家庭',
  'Your first kid': '你的第一个孩子',
  'Review and create': '检查并创建',
  'Loading session…': '正在加载会话…',
  'Wrong account': '账户不对',
  'Family setup is for parents.': '家庭设置仅限家长使用。',
  "You're signed in as {role} ({email}). Creating a family needs a parent account. Sign out and register with a different email.":
    '你当前登录的身份是 {role}（{email}）。创建家庭需要家长账户。请退出登录，并用另一个邮箱注册。',
  'Sign out & use a parent email →': '退出登录并使用家长邮箱 →',
  "The kid code didn't match, so your kid isn't linked yet. Check the code with the teacher, then use Family → Add kid → “I have a kid code”.":
    '孩子代码不匹配，所以还没有关联你的孩子。请向老师确认代码，然后在“家庭 → 添加孩子 → 我有孩子代码”中重试。',
  "We couldn't link your kid yet. You can claim them any time from Family → Add kid → “I have a kid code”.":
    '暂时无法关联你的孩子。你可以随时在“家庭 → 添加孩子 → 我有孩子代码”中认领。',
  'You already have a family. Taking you back…': '你已经有家庭了，正在带你返回…',
  "Your family is saved. We couldn't add your kid yet: {message}":
    '你的家庭已保存，但暂时无法添加孩子：{message}',
  "Your family is saved. We couldn't add your kid yet. Check your connection and try again.":
    '你的家庭已保存，但暂时无法添加孩子。请检查网络后重试。',
  'Registration failed.': '注册失败。',
  'Check your family details, then continue again.': '请检查家庭信息后再继续。',
  "Check your kid's details, then continue again.": '请检查孩子的信息后再继续。',
  'Check the highlighted details, then try again.': '请检查标出的信息后再试。',
  'Already set up': '已完成设置',
  'Your family is ready.': '你的家庭已准备好。',
  '{email} already has an Airbotix family. Go back to Hangar — it connects by itself.':
    '{email} 已经有 Airbotix 家庭了。请返回 Hangar，它会自动连接。',
  'All set!': '设置完成！',
  'Welcome to ': '欢迎来到 ',
  '.': '。',
  'Your family is ready. Go back to Hangar — it connects by itself in a few seconds.':
    '你的家庭已准备好。请返回 Hangar，几秒钟后它会自动连接。',
  'Your family is ready. Save this family code — your kid types it to sign in.':
    '你的家庭已准备好。请保存这个家庭代码，孩子登录时需要输入它。',
  'Go to dashboard →': '前往首页 →',
  'Set up your ': '设置你的',
  "Takes about 90 seconds. You'll get a family code once you're done.":
    '大约需要 90 秒，完成后你会获得一个家庭代码。',
  'Mobile number (required)': '手机号码（必填）',
  'We use this for course and account notifications or support. Marketing messages still require your permission.':
    '我们用它来发送课程和账户通知，或提供支持。营销信息仍需你的许可。',
  'The Wang Family': '王家',
  'Which city are you in? (optional)': '你在哪个城市？（选填）',
  'Which state? (optional)': '在哪个州？（选填）',
  'Postcode (optional)': '邮政编码（选填）',
  'How did you find us? (optional)': '你是怎么找到我们的？（选填）',
  'How did you hear about us?': '你是通过什么渠道了解我们的？',
  'Choose one…': '请选择一项…',
  Search: '搜索',
  'Social media': '社交媒体',
  'A friend / referral': '朋友 / 推荐',
  "My child's school": '孩子的学校',
  'An event': '某个活动',
  'Word of mouth': '口碑相传',
  'Just found you online': '在网上偶然发现',
  'I have a kid code from a workshop': '我有工作坊的孩子代码',
  'The kid code links the account your kid used at the workshop — and everything they made — to your new family.':
    '孩子代码会把孩子在工作坊使用的账户，以及他们做的所有作品，关联到你的新家庭。',
  'Nickname (optional — keeps the workshop one)': '昵称（选填，不填则沿用工作坊的昵称）',
  'Review your setup': '检查你的设置',
  'Family: {name}': '家庭：{name}',
  'Kid: {name} · Age {age}': '孩子：{name} · {age} 岁',
  'Workshop profile': '工作坊资料',
  'School: {name}': '学校：{name}',
  'Your family is already saved. Retry will add only your kid.':
    '你的家庭已保存，重试时只会添加孩子。',
  'Nothing is created until you select Create family below.':
    '在你点击下方“创建家庭”之前，不会创建任何内容。',
  'I am the parent or legal guardian of the kids on this account, and I agree to the {terms}, the {privacy}, and the {consent} terms.':
    '我是此账户下孩子的家长或法定监护人，并同意{terms}、{privacy}和{consent}条款。',
  'Terms of Service': '服务条款',
  'Parental Consent': '家长同意书',
  'Retry adding kid →': '重试添加孩子 →',
  'Create family →': '创建家庭 →',
  "We record the date and document version of your agreement. You can export or delete all your family's data anytime from Settings.":
    '我们会记录你同意的日期和文件版本。你可以随时在设置中导出或删除全部家庭数据。',
  'Loading your account…': '正在加载你的账户…',
  Membership: '会员',
  'Set up your account to manage a membership.': '设置好账户后，才能管理会员。',
  'Back to your account': '返回我的账户',
  'Learning and creation, with a clear family budget': '学习与创作，家庭预算一目了然',
  'See a complete outcome before choosing your Airbotix membership.':
    '选择 Airbotix 会员之前，先看看完整的成果。',
  'Explore a prepared member workspace': '体验已准备好的会员空间',
  'No membership': '没有会员',
  'Payment is being checked': '正在核对付款',
  'Renewal cancelled': '已取消续订',
  'Renewal payment needs attention': '续订付款需要处理',
  'Membership period ended': '会员期已结束',
  'Billing result needs checking': '账单结果需要核对',
  'State needs checking': '状态需要核对',
  'Demo update applied to this isolated session.': '演示修改已应用到这个独立会话。',
  'Billing request recorded. Check the confirmed state below.':
    '账单请求已记录，请查看下方确认后的状态。',
  'Billing could not be checked. Keep this operation and try checking its status.':
    '暂时无法核对账单。请保留此操作，并稍后再查看状态。',
  'This content could not be opened.': '无法打开此内容。',
  'The billing link could not be verified.': '无法验证账单链接。',
  'Reload the plans before continuing.': '请先重新加载套餐再继续。',
  'Airbotix membership': 'Airbotix 会员',
  'One family membership. Published learning content and a monthly Stars allowance.':
    '一份家庭会员，包含已发布的学习内容和每月星星额度。',
  'Current membership': '当前会员',
  'Your membership': '你的会员',
  'Loading membership…': '正在加载会员信息…',
  'We could not check your membership. Your saved work has not changed.':
    '暂时无法查询你的会员状态，你已保存的作品没有任何变化。',
  'Paid access ends: {date}.': '付费权益截止：{date}。',
  'No automatic renewal is scheduled.': '没有安排自动续订。',
  'Your billing agreement determines the next renewal.': '下次续订由你的扣款协议决定。',
  'Next payment: {date}.': '下次付款：{date}。',
  'Next paid-period Stars allowance: {date}.': '下个付费周期的星星额度发放日：{date}。',
  '{tier} {cycle} starts from {date}, after verified payment.':
    '{tier} {cycle} 将在付款核实后，自 {date} 起生效。',
  'Check payment status': '查看付款状态',
  'Resume automatic renewal': '恢复自动续订',
  'Cancel automatic renewal': '取消自动续订',
  'Included learning content': '包含的学习内容',
  'Self-paced course': '自学课程',
  'Complete learning resource': '完整学习资源',
  'Eligible course discount': '符合条件的课程折扣',
  'Open complete resource': '打开完整资源',
  'Open course catalogue': '打开课程目录',
  'Complete member resource': '完整的会员资源',
  'Close resource': '关闭资源',
  'Refresh plans': '刷新套餐',
  'Choose your membership': '选择你的会员',
  'Monthly billing · annual plans are not offered.': '按月计费，暂不提供年付套餐。',
  'Loading plans…': '正在加载套餐…',
  'Plans could not be loaded.': '无法加载套餐。',
  'Membership preview · sales are not open. No charge or membership activation is available.':
    '会员预览 · 暂未开放购买，不会扣费，也无法开通会员。',
  '/month': '/月',
  '{stars} Stars each month': '每月 {stars} 星星',
  'Monthly membership Stars reset each paid month; unused Stars do not roll over. Recharge Stars are kept separately.':
    '会员每月星星会在每个付费月重置，未用完的星星不会结转。充值星星单独保留。',
  'Member learning resources.': '会员学习资源。',
  'Member resources and explicitly included self-paced courses.':
    '会员资源，以及明确包含的自学课程。',
  '{percent}% off listed eligible courses; offers do not automatically combine.':
    '列出的符合条件的课程可享 {percent}% 折扣，优惠不会自动叠加。',
  'Review next-cycle change': '查看下个周期的变更',
  'Review subscription': '查看订阅',
  'Sign in to manage membership': '登录后管理会员',
  'AI still spends Stars at its displayed server price. No unlimited AI. Classes and separately purchased products are included only when explicitly listed.':
    'AI 仍按显示的服务器价格消耗星星，不提供无限 AI。班级和单独购买的产品仅在明确列出时才包含在内。',
  'Tax display awaits merchant configuration.': '税费显示待商户配置。',
  'Displayed prices include configured tax.': '显示的价格已包含配置的税费。',
  'Tax is shown in the final checkout total.': '税费会显示在最终结账总额中。',
  'Confirm cancellation of automatic renewal': '确认取消自动续订',
  'Confirm automatic renewal': '确认自动续订',
  'Paid access continues until {date}. Unused membership Stars expire at that boundary. Recharge Stars, saved projects and independently bought courses remain.':
    '付费权益持续到 {date}。未用完的会员星星将在该时间点失效；充值星星、已保存的项目和单独购买的课程不受影响。',
  'Your current paid access remains until {date}. The new {tier} {cycle} plan ({price} per month, {stars} Stars each month) applies from the next paid cycle without an immediate proportional charge.':
    '你当前的付费权益持续到 {date}。新的 {tier} {cycle} 套餐（每月 {price}，每月 {stars} 星星）从下个付费周期开始生效，不会立即按比例扣费。',
  '{name} · {price} per month. Automatic renewal continues until cancelled.':
    '{name} · 每月 {price}。自动续订会持续到你取消为止。',
  'I have reviewed the amount, billing cycle, included content and automatic renewal.':
    '我已查看金额、计费周期、包含的内容和自动续订。',
  'Read membership terms': '阅读会员条款',
  'Review and accept automatic renewal before continuing.': '请先查看并接受自动续订，再继续。',
  'Apply Demo change': '应用演示修改',
  'Confirm request': '确认请求',
  'Keep current state': '保持当前状态',
  'Stars and paid periods': '星星与付费周期',
  '{stars} Stars available in your shared family wallet': '你的共享家庭钱包中有 {stars} 星星可用',
  'Membership Stars · used first': '会员星星 · 优先使用',
  'Expires: {date} · no rollover': '到期：{date} · 不结转',
  'Recharge & other permanent Stars': '充值及其他永久星星',
  'Kept when membership resets or ends': '会员重置或结束时仍会保留',
  'Balance sources have not been recorded.': '尚未记录余额来源。',
  'Demo month advanced. Unused membership Stars expired; recharge Stars were kept.':
    '演示月份已推进：未用完的会员星星已失效，充值星星已保留。',
  'Preview next month (Demo)': '预览下个月（演示）',
  '{stars} Stars': '{stars} 星星',
  'Membership Stars reset for each verified paid month. Unused membership Stars expire at the period end and do not roll over. Recharge and other permanent Stars remain. Spending uses membership Stars first.':
    '会员星星会在每个已核实的付费月重置。未用完的会员星星在周期结束时失效，不会结转；充值星星和其他永久星星会保留。消费时优先使用会员星星。',
  'Monthly allowance resets': '每月额度重置',
  '{date} · reset to {stars} member Stars (no rollover)':
    '{date} · 重置为 {stars} 会员星星（不结转）',
  'No membership allowance resets recorded.': '没有会员额度重置记录。',
  Invoices: '发票',
  'Open invoice': '打开发票',
  'No verified membership invoices.': '没有已核实的会员发票。',
  'Auto-topup settings saved.': '自动充值设置已保存。',
  'Could not save auto-topup.': '无法保存自动充值设置。',
  'Test charge sent. A$1 will be refunded.': '测试扣款已发出，A$1 将会退回。',
  'Test charge failed.': '测试扣款失败。',
  'We couldn’t load auto-topup safely': '无法安全加载自动充值设置',
  'Your settings and saved cards have not been changed or shown as missing.':
    '你的设置和已保存的银行卡没有被更改，也没有被显示为缺失。',
  'Choose a saved card before switching auto-topup on.':
    '开启自动充值前，请先选择一张已保存的银行卡。',
  'Wallet safety net': '钱包安全网',
  'Never run out mid-mission': '创作到一半，星星不会用完',
  'Set a low-balance trigger, choose a Stars pack and cap your spending. You stay in control of every automatic top-up.':
    '设置低余额触发线，选择星星套餐并设定消费上限。每一次自动充值都由你掌控。',
  'Auto-topup on': '自动充值已开启',
  'Auto-topup off': '自动充值已关闭',
  'Choose your low-balance trigger': '选择低余额触发线',
  'We check after Stars are used. No charge happens above this level.':
    '星星被使用后我们会检查余额，余额高于这个数值时不会扣款。',
  'about A${amount}': '约 A${amount}',
  'Pick the pack to add': '选择要充值的套餐',
  'The selected pack is purchased only when the balance crosses your trigger.':
    '只有当余额低于触发线时，才会购买所选套餐。',
  'Choose a current saved card': '请选择一张当前可用的银行卡',
  'The card previously selected for auto-topup is no longer active. Automatic charges remain unavailable until you choose another card and save.':
    '之前为自动充值选择的银行卡已不可用。在你选择另一张卡并保存之前，无法自动扣款。',
  'Set your safety limits': '设置安全额度',
  'Charges stop automatically when either spending cap is reached.':
    '任一消费上限达到后，扣款会自动停止。',
  'Daily maximum': '每日上限',
  '/day': '/天',
  'Monthly maximum': '每月上限',
  'Pause after failed charges': '扣款失败后暂停',
  '1 consecutive failure': '连续失败 1 次',
  '{count} consecutive failures': '连续失败 {count} 次',
  'Recent auto-topups': '最近的自动充值',
  succeeded: '成功',
  failed: '失败',
  'Setup summary': '设置摘要',
  'Your safety net': '你的安全网',
  Trigger: '触发线',
  'Below {stars}★': '低于 {stars}★',
  Adds: '充值内容',
  '{stars}★ for A${price}': '{stars}★，A${price}',
  'Daily cap': '每日上限',
  'Monthly cap': '每月上限',
  'Choose a current saved card to finish setup.': '请选择一张当前可用的银行卡以完成设置。',
  'Save auto-topup': '保存自动充值',
  'Settings saved': '设置已保存',
  'Testing…': '测试中…',
  'Test saved card (A$1)': '测试已保存的银行卡（A$1）',
  'The test charge is refunded. Save changes first.': '测试扣款会退回。请先保存修改。',
  'Loading auto-topup': '正在加载自动充值',
  'the media release': '媒体授权书',
  'the competition terms': '比赛条款',
  'has not been signed yet': '尚未签署',
  'has expired and needs signing again': '已过期，需要重新签署',
  'was updated and needs signing again': '已更新，需要重新签署',
  'still needs signing': '仍需签署',
  '{name} {reason}': '{name}{reason}',
  ' and ': '，且',
  '{message} Specifically, {detail}.': '{message}具体来说，{detail}。',
  'We could not find that child on your family profile. Choose a child below.':
    '在你的家庭资料中找不到这个孩子，请在下方选择一个孩子。',
  'We could not open that child’s entry for this challenge. Choose a child below to start again.':
    '无法打开这个孩子在本次挑战赛的报名记录。请在下方选择孩子，重新开始。',
  'We could not record your choices. Try again.': '无法记录你的选择，请重试。',
  'We could not record your acceptance. Try again.': '无法记录你的同意，请重试。',
  'We could not record that. Try ticking the box again.': '无法记录这一操作，请重新勾选。',
  'We could not start checkout. Try again.': '无法开始结账，请重试。',
  'We could not load this challenge.': '无法加载这个挑战赛。',
  'We could not load the consent forms.': '无法加载同意书表单。',
  'Loading this challenge…': '正在加载这个挑战赛…',
  'Back to my account →': '返回我的账户 →',
  'Entry confirmed': '报名已确认',
  '{name} is entered': '{name} 已报名',
  'Registration confirmed': '报名已确认',
  '{name} · entry status: {status}.': '{name} · 报名状态：{status}。',
  'registration confirmed': '报名已确认',
  '{count} Stars have been added to your wallet.': '{count} 星星已存入你的钱包。',
  '{count} Stars have been added to your family wallet.': '{count} 星星已存入你的家庭钱包。',
  'The Stars that come with an entry have not been added yet. They land automatically — check your wallet again shortly.':
    '随报名赠送的星星尚未到账，会自动发放，请稍后再查看钱包。',
  'Submissions open {open} and close {close}.': '作品提交于 {open} 开始，{close} 截止。',
  'Open {name}’s challenge →': '打开 {name} 的挑战赛 →',
  'View wallet →': '查看钱包 →',
  'We have not received your payment confirmation yet. If you completed payment, do not pay again — the entry confirms itself the moment confirmation arrives.':
    '我们还没有收到你的付款确认。如果你已经完成付款，请不要重复付款，确认一到，报名就会自动生效。',
  'Hang tight — we are waiting for your payment confirmation. This usually takes a few seconds.':
    '请稍等，我们正在等待付款确认，通常只需几秒钟。',
  'I did not complete payment': '我没有完成付款',
  'Entry fee {fee} · submissions {from} – {to} · results {results}':
    '报名费 {fee} · 作品提交 {from} – {to} · 公布结果 {results}',
  'Who are you entering?': '你要为谁报名？',
  'Whose entry do you want to check?': '你想查看谁的报名？',
  'This child has no confirmed entry for this edition. New forms and payments are not available after registration closes.':
    '这个孩子在本届没有已确认的报名。报名截止后，无法再提交新的表单或付款。',
  'Back to the challenge': '返回挑战赛',
  'Loading the forms…': '正在加载表单…',
  'Could not load the forms': '无法加载表单',
  'Step 1 of 2 · {label}': '第 1 步 / 共 2 步 · {label}',
  'Your consent': '你的同意',
  'Parent authorization': '家长授权',
  'Authorize the entry first': '先完成报名授权',
  'Complete the media choices and competition terms here. No payment is taken in this step. The payment screen opens only after both forms are signed.':
    '请在这里完成媒体选项和比赛条款。这一步不会扣款，两份表单都签署后才会打开付款页面。',
  'The competition terms open after the media choices are signed.':
    '签署媒体选项之后，才会打开比赛条款。',
  'Continue to payment →': '继续付款 →',
  'Step 2 of 2 · Confirm and pay': '第 2 步 / 共 2 步 · 确认并付款',
  'Your consent is complete': '你的同意已完成',
  'Parent authorization complete': '家长授权已完成',
  'Media choices and competition terms are both signed for {name}.':
    '已为 {name} 签署媒体选项和比赛条款。',
  'this child': '这个孩子',
  'Review or update authorization': '查看或更新授权',
  'Entry fee': '报名费',
  '{fee}, paid once at checkout. Your entry is confirmed when the payment is received.':
    '{fee}，在结账时一次性支付。收到付款后，你的报名就会确认。',
  'Pay {fee} & enter →': '支付 {fee} 并报名 →',
  'You will pay securely on our payment page (Airwallex). Come back here afterwards to see the entry confirmed.':
    '你将在我们的付款页面（Airwallex）安全付款，付款后请回到这里查看报名确认情况。',
  'Registration progress': '报名进度',
  Complete: '已完成',
  'Confirm and pay': '确认并付款',
  'Enter the challenge': '报名挑战赛',
  'Register a child': '为孩子报名',
  'Challenge entry': '挑战赛报名',
};
